
/**
 * Si la petición a la API falla o se demora más de 30s, enviará a consola un mensaje con el error
 * @param error 
 */
/* eslint-disable */
export function showConsoleError(error: any) {

    if (error.code === "ECONNABORTED") {
        console.error('Se excedió el tiempo de 30s en la petición')
    }
    if (error.code === "ERR_BAD_REQUEST") {
        console.error('No se encontró la ruta de la API')
    }
    if (error.code === "ERR_BAD_RESPONSE") {
        console.error('Problemas en las APIS')
    }
    if (error.code === "ERR_NETWORK") {
        console.error('Se cayeron las APIS')
    }
}